import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ACTIONS from '../redux/actions/UI';

import PropTypes from 'prop-types';
import * as Cache from '../utils/Cache';

import axios from 'axios';

import Settings from '../settings';

import { Link } from 'react-router-dom';

const remote = Settings.remote;

function stateToProps(state) {
  return {
    entry: state.Page.entry,
  };
}

function dispatchToProps(dispatch) {
  return {
    dataLoading: bindActionCreators(ACTIONS.dataLoading, dispatch),
    dataLoaded: bindActionCreators(ACTIONS.dataLoaded, dispatch),
    projectClick: bindActionCreators(ACTIONS.projectClick, dispatch),
  };
}

class PreloadLink extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  handleClick = (evt) => {
    evt.preventDefault();
    const _this = this;
    // const slug = this.props.to === '/' ? 'showcase' : this.props.to;

    let slug = this.props.to;

    if (slug === '/') {
      slug = 'landing';
    } else if (slug === '/projects' || slug === '/projects/') {
      slug = 'showcase';
    }

    /*const preload = Api.preload(slug,() => {
			this.context.router.history.push(this.props.to)
		})*/

    const cached = Cache.fetch(slug);

    if (cached) {
      this.context.router.history.push(_this.props.to);
    } else {
      let dataRec = false;

      // only show loading indicator if it take over half a second
      setTimeout(() => {
        if (!dataRec) _this.props.dataLoading();
      }, 500);

      this.props.projectClick();

      axios.get(remote + slug + '.json').then((response) => {
        dataRec = true;
        _this.props.dataLoaded();
        Cache.save(slug, response);
        setTimeout(() => {
          _this.context.router.history.push(_this.props.to);
        }, 500);
      });
    }
  };

  render() {
    return (
      <Link onClick={this.handleClick} to={this.props.to}>
        {this.props.children}
      </Link>
    );
  }
}

export default connect(stateToProps, dispatchToProps)(PreloadLink);



// WEBPACK FOOTER //
// ./src/js/components/PreloadLink.js